module.exports = __webpack_public_path__ + "static/img/advantage04.24e2130.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/advantage04.png
// module id = 0yUq
// module chunks = 1